import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import imagePlaceholder from '../../../../../shared/assets/img/noimage.png';

lessRequire('modules/offers/components/promo-gallery/entity.less');

const propTypes = {
	src: PropTypes.string,
	index: PropTypes.number,
	onClickAction: PropTypes.func,
	activeClassName: PropTypes.string
};

const defaultProps = {
	activeClassName: ''
};

const Entity = ({ src, index, onClickAction, activeClassName }) => {
	const element = getElement(src, { video: { controls: false } });
	return (
		<a href="javascript:;"
			onClick={() => onClickAction(index)}
			className={cn(
				'promo-thumb',
				getType(src) === 'pdf' && 'promo-thumb--pdf',
				activeClassName
			)}>
			{element}
		</a>
	);

};

Entity.defaultProps = defaultProps;
Entity.propTypes = propTypes;
export default Entity;

// functions
export const getElement = (src, settings = { video: { controls: true } }) => {
	const type = getType(src);

	switch (type) {
		case 'img':
			return (
				<img src={src} onError={e => (e.target.src = imagePlaceholder)} />
			);
		case 'pdf':
			return (
				<object
					width="800"
					height="600"
					type="application/pdf"
					data={`${src}?#view=scale&toolbar=0&navpanes=0&scrollbar=0`}
				>
					<a href={src}>Download pdf</a>
				</object>
			);
		case 'video':
			return (
				<video src={src} style={{ display: 'flex' }} controls={settings.video.controls}>
					Sorry, your browser doesn't support embedded videos,
					but don't worry, you can <a href={src}>download it</a>
					and watch it with your favorite video player!
				</video>
			);
	}
};

const extensions = {
	video: ['mp4', 'avi', 'mkv', 'mov', 'flv', 'vob', 'wmv', 'mpeg', 'ogg', 'webm']
};

export const getType = src => {
	const extension = src.split('.').pop().toLowerCase();

	if (extension === 'pdf') {
		return 'pdf';
	}

	if (extensions.video.includes(extension)) {
		return 'video';
	}

	return 'img';
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/entity.js